/**
 * What the cart will actually charge for the selected tier, plus the figures for the
 * subscription-savings line, derived from the price rows helper-price-store-json emits
 * (see snippets/helper-price-json.liquid):
 *   - one-time rows carry `quantity` and are LINE TOTALS (the multi-unit discount is baked in)
 *   - subscription rows carry `selling_plan` and are PER-UNIT (qty 1) — one plan per tier
 * All amounts are integer cents.
 *
 * `savings` ("Ersparnis") is what subscribing saves against buying the SAME quantity once:
 * one-time tier total minus subscription total. That is the comparison the buy-box tiles
 * make, so the sticky bar quotes the same number (e.g. Primal Greens ×2: 92,68 − 77,24 = 15,44 €).
 * `percentage` is the plan's discount against the undiscounted price (20 / 25 / 30 %).
 */
export function resolveTierPricing({prices = [], variantId, quantity, sellingPlanId}) {
  const qty = Math.max(1, Math.trunc(Number(quantity)) || 1);
  const rows = (prices ?? []).filter(p => p && p.id === variantId);

  const oneTimeTier = rows.find(p => !p.selling_plan && p.quantity === qty);
  const oneTimeUnit = rows.find(p => !p.selling_plan && p.quantity == null);
  const oneTimeTotal = oneTimeTier?.price ?? (oneTimeUnit ? oneTimeUnit.price * qty : null);

  const base = {quantity: qty, isSubscription: !!sellingPlanId, lineTotal: oneTimeTotal, percentage: 0, savings: 0};
  if (!sellingPlanId) return base;

  // Unknown plan id (e.g. store not yet synced after a product swap): fall back to the first
  // subscription row, mirroring priceStore.pricesQtd1.
  const subscription = rows.find(p => p.selling_plan === sellingPlanId) ?? rows.find(p => p.selling_plan);
  if (!subscription) return base;

  const lineTotal = subscription.price * qty;
  const fullTotal = (subscription.compareAtPrice ?? 0) * qty;
  const percentage = fullTotal > lineTotal ? Math.round(100 - (100 * lineTotal) / fullTotal) : 0;
  const reference = oneTimeTotal ?? fullTotal;
  const savings = Math.max(0, reference - lineTotal);

  return {quantity: qty, isSubscription: true, lineTotal, percentage, savings};
}
